const r = {
  "cdr-rating__icon": "cdr-rating__icon_15-6-1-beta-4",
  "cdr-rating__count": "cdr-rating__count_15-6-1-beta-4",
  "cdr-rating": "cdr-rating_15-6-1-beta-4",
  "cdr-rating__number": "cdr-rating__number_15-6-1-beta-4",
  "cdr-rating__ratings": "cdr-rating__ratings_15-6-1-beta-4",
  "cdr-rating__caption-sr": "cdr-rating__caption-sr_15-6-1-beta-4",
  "cdr-rating--linked": "cdr-rating--linked_15-6-1-beta-4",
  "cdr-rating__star": "cdr-rating__star_15-6-1-beta-4",
  "cdr-rating__star--null-fill": "cdr-rating__star--null-fill_15-6-1-beta-4",
  "cdr-rating__star--null-outline": "cdr-rating__star--null-outline_15-6-1-beta-4",
  "cdr-rating__star--partial-fill": "cdr-rating__star--partial-fill_15-6-1-beta-4",
  "cdr-rating__star--partial-stroke": "cdr-rating__star--partial-stroke_15-6-1-beta-4",
  "cdr-rating__star--filled": "cdr-rating__star--filled_15-6-1-beta-4",
  "cdr-rating__star--empty": "cdr-rating__star--empty_15-6-1-beta-4",
  "cdr-rating__star--small": "cdr-rating__star--small_15-6-1-beta-4",
  "cdr-rating__star--medium": "cdr-rating__star--medium_15-6-1-beta-4",
  "cdr-rating__star--large": "cdr-rating__star--large_15-6-1-beta-4",
  "cdr-rating__star--small@xs": "cdr-rating__star--small@xs_15-6-1-beta-4",
  "cdr-rating__star--medium@xs": "cdr-rating__star--medium@xs_15-6-1-beta-4",
  "cdr-rating__star--large@xs": "cdr-rating__star--large@xs_15-6-1-beta-4",
  "cdr-rating__star--small@sm": "cdr-rating__star--small@sm_15-6-1-beta-4",
  "cdr-rating__star--medium@sm": "cdr-rating__star--medium@sm_15-6-1-beta-4",
  "cdr-rating__star--large@sm": "cdr-rating__star--large@sm_15-6-1-beta-4",
  "cdr-rating__star--small@md": "cdr-rating__star--small@md_15-6-1-beta-4",
  "cdr-rating__star--medium@md": "cdr-rating__star--medium@md_15-6-1-beta-4",
  "cdr-rating__star--large@md": "cdr-rating__star--large@md_15-6-1-beta-4",
  "cdr-rating__star--small@lg": "cdr-rating__star--small@lg_15-6-1-beta-4",
  "cdr-rating__star--medium@lg": "cdr-rating__star--medium@lg_15-6-1-beta-4",
  "cdr-rating__star--large@lg": "cdr-rating__star--large@lg_15-6-1-beta-4",
  "cdr-rating--large": "cdr-rating--large_15-6-1-beta-4",
  "cdr-rating--medium": "cdr-rating--medium_15-6-1-beta-4",
  "cdr-rating--small": "cdr-rating--small_15-6-1-beta-4",
  "cdr-rating--small@xs": "cdr-rating--small@xs_15-6-1-beta-4",
  "cdr-rating--medium@xs": "cdr-rating--medium@xs_15-6-1-beta-4",
  "cdr-rating--large@xs": "cdr-rating--large@xs_15-6-1-beta-4",
  "cdr-rating--small@sm": "cdr-rating--small@sm_15-6-1-beta-4",
  "cdr-rating--medium@sm": "cdr-rating--medium@sm_15-6-1-beta-4",
  "cdr-rating--large@sm": "cdr-rating--large@sm_15-6-1-beta-4",
  "cdr-rating--small@md": "cdr-rating--small@md_15-6-1-beta-4",
  "cdr-rating--medium@md": "cdr-rating--medium@md_15-6-1-beta-4",
  "cdr-rating--large@md": "cdr-rating--large@md_15-6-1-beta-4",
  "cdr-rating--small@lg": "cdr-rating--small@lg_15-6-1-beta-4",
  "cdr-rating--medium@lg": "cdr-rating--medium@lg_15-6-1-beta-4",
  "cdr-rating--large@lg": "cdr-rating--large@lg_15-6-1-beta-4"
};
export {
  r as default
};
